<template>
  <div class="area-school-select">
    <el-select v-model="province" placeholder="省" clearable @change="handleProvinceChange">
      <el-option v-for="item in provinceOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
    </el-select>
    <el-select v-model="city" placeholder="市" clearable @change="handleCityChange">
      <el-option v-for="item in cityOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
    </el-select>
    <el-select v-model="country" placeholder="区" clearable @change="handleCountryChange">
      <el-option v-for="item in countryOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
    </el-select>
    <el-select v-model="school" placeholder="学校" clearable @change="handleSchoolChange" style="width: 150px; margin-right: 0">
      <el-option v-for="item in schoolOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
    </el-select>
  </div>
</template>

<script>
import { PersonalPostDicAreaList, PersonalPostEudSchoolList } from "@/views/index/api/personalCenter/api.personalCenter.js";

export default {
  name: "AreaSchoolSelect",
  data() {
    return {
      provinceOptions: [],
      cityOptions: [],
      countryOptions: [],
      schoolOptions: [],
      province: "",
      city: "",
      country: "",
      school: "",
      areaCode: "",
    }
  },
  methods: {
    handleProvinceChange(val) {
      this.areaCode = val;
      this.city = "";
      this.country = "";
      this.school = "";
      this.cityOptions = [];
      this.countryOptions = [];
      this.schoolOptions = [];
      this.getArea(2, val);
      this.$emit("input", [this.areaCode, this.school]);
    },
    handleCityChange(val) {
      this.areaCode = val || this.province;
      this.country = "";
      this.school = "";
      this.countryOptions = [];
      this.schoolOptions = [];
      this.getArea(3, val);
      this.$emit("input", [this.areaCode, this.school]);
    },
    handleCountryChange(val) {
      this.areaCode = val || this.city;
      this.school = "";
      this.schoolOptions = [];
      this.getSchool(val);
      this.$emit("input", [this.areaCode, this.school]);
    },
    handleSchoolChange(val) {
      this.$emit("input", [this.areaCode, val]);
    },
    getArea(type, code) {
      if (type !== 1 && !code) return;
      PersonalPostDicAreaList({ type, code }).then(res => {
        if (res && res.result) {
          if (type === 1) {
            this.provinceOptions = res.result;
          } else if (type === 2) {
            this.cityOptions = res.result;
          } else {
            this.countryOptions = res.result;
          }
        }
      })
    },
    getSchool(code) {
      PersonalPostEudSchoolList({code}).then(res => {
        if (res && res.result) {
          this.schoolOptions = res.result;
        }
      })
    },
  },
  created() {
    this.getArea(1);
  },
}
</script>

<style lang="scss">
.area-school-select {
  display: inline-flex;
  .el-select {
    margin-right: 10px;
    width: 120px;
  }
}
</style>